export default "__VITE_ASSET__BHftMRog__"